export const version = "web/5.7.0";
//# sourceMappingURL=_version.js.map